// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flapple_gmax: PokeData = {
  "id": 10216,
  "name": "flapple-gmax",
  "height": 240,
  "weight": 10000,
  "base_experience": 170,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [],
  "moves": [
    "great-roar",
    "branch-poke",
    "dragon-rush",
    "frenzy-plant",
    "leaf-tornado",
    "aromatherapy",
    "wood-hammer",
    "draco-meteor",
    "dragon-fang",
    "dragon-breath",
    "bullet-seed",
    "scale-shot",
    "dragon-claw"
  ],
  "evolution_chain": {
    "id": 442,
    "item": null,
    "species": [
      {
        "name": "applin",
        "order": 840,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flapple",
        "order": 841,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "tart-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "appletun",
        "order": 842,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sweet-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dipplin",
        "order": 1013,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": []
      },
      {
        "name": "hydrapple",
        "order": 1021,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 1011,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 112,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
